import { AfterViewChecked, ChangeDetectorRef, Component, inject, Input, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchMapComponent } from '@aipb/gulliver/catalog/feature-search-map';
import { calculateGridLevel, normalizeMapCoordinates } from '@aipb/gulliver/catalog/util';
import { finalize } from 'rxjs/operators';
import { SearchService } from '@aipb/gulliver/catalog/data-access';
import { FacetItem, SearchItem, SearchTab } from '@aipb/gulliver/catalog/model';
import { CastorService } from '@aipb/gulliver/castor/data-access';
import { HeatmapInts2D } from '@aipb/gulliver/castor/model';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'cat-facet-map',
  standalone: true,
  imports: [CommonModule, SearchMapComponent, MatButton, MatIcon],
  templateUrl: './facet-map.component.html',
  styleUrl: './facet-map.component.scss'
})
export class FacetMapComponent implements AfterViewChecked {
  @Input() searchItem: SearchItem;
  @Input() facetItem: FacetItem;

  @ViewChild(SearchMapComponent) searchMap: SearchMapComponent;

  private searchService = inject(SearchService);
  private castor = inject(CastorService);
  private cdr = inject(ChangeDetectorRef);

  heatmap = signal<HeatmapInts2D>(null);

  ngAfterViewChecked(): void {
    if (this.searchMap) {
      this.searchMap.updateMap();
    }
  }

  onMapChange(map: SearchMapComponent): void {
    this.searchService.updateMapResultCount(this.searchItem, this.searchItem.search.q, this.searchMap.getCoordinates());

    const zoom = map.getZoom();

    this.castor
      .heatmapInts2D({
        query: this.searchItem.search.q,
        fieldId: 'Heatmap',
        rectangle: normalizeMapCoordinates(map.getCoordinates()).join(','), //`${normalizedCoordinates[0]},${normalizedCoordinates[1]},${normalizedCoordinates[2]},${normalizedCoordinates[3]}`,
        gridLevel: calculateGridLevel(zoom, map.getMinZoom(), map.getMaxZoom())
      })
      .pipe(
        finalize(() => {
          this.cdr.detectChanges();
        })
      )
      .subscribe((data) => {
        this.heatmap.set(data);
      });
  }

  onSearch(): void {
    const searchTab: SearchTab = {
      solrSearchParams: {
        query: this.searchItem.search.q,
        coreId: this.searchItem.coreId,
        sort: this.searchItem.search_sort
      },
      settings: {}
    };

    const coordinates = normalizeMapCoordinates(this.searchMap.getCoordinates());

    if (coordinates && coordinates.length > 0) {
      searchTab.coordinates = coordinates;
      searchTab.solrSearchParams = {
        ...searchTab.solrSearchParams,
        spatialFilter: {
          spatialType: 'rectangle',
          spatialField: 'Coordinates',
          rectangle: coordinates.join(',')
        }
      };
    }

    this.searchService.addTab(searchTab, true);
  }
}
